import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { PulseLoader } from 'react-spinners';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { verifyStoreRole } from '../../../../../../queries';

import { Content, Button } from './styles';
import { Label, Input } from '../../../../../../assets/styles';

class VerifyRoleFormModal extends Component {
  state = {
    loading: false,
    email: '',
    role: '',
    emailFocus: false,
    emailError: false,
  }

  openVerifyRoleFormModal = (role) => {
    this.setState({
      email: '',
      role,
      emailFocus: false,
      emailError: false,
    });
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const { emailError } = this.state;

    if (!emailError) {
      this.setState({ loading: true });

      const { email, role } = this.state;

      let roleType;

      if (role === 'Dono') {
        roleType = 'owner';
      } else if (role === 'Gerente') {
        roleType = 'manager';
      } else roleType = 'employee';

      this.props
        .verifyStoreRole({
          variables: { storeId: this.props.storeId, email },
        })
        .then(async () => {
          this.setState({ loading: false });
          this.props.close();
          this.props.success(email);
        })
        .catch((err) => {
          this.setState({ loading: false });

          if (/email/i.test(err.message)) {
            this.props.confirmModal(email, roleType);
          }

          if (/linked/i.test(err.message)) {
            this.props.close();
            this.props.alert.error('O endereço de e-mail informado já possui uma função administrativa');
          }
        });
    }
  }

  validateInputs = async () => {
    this.setState({ emailError: false });

    const { email } = this.state;

    const emailReg = /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/;
    if (!emailReg.test(email)) this.setState({ emailError: true });
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const { email, emailFocus, emailError } = this.state;
    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.roleFormModal = ref; }}
      >
        <Content>
          <h2>Adicionar uma nova função administrativa</h2>
          <p className="subtitle">
            {'Informe o endereço de e-mail para adicionar uma nova função administrativa'}
          </p>
          <Label>
            <p className="fieldName">E-mail</p>
            <Input
              type="text"
              name="email"
              value={email}
              error={emailError}
              onFocusInput={emailFocus}
              onChange={this.handleInputChange}
              onFocus={() => this.onFocus('emailFocus')}
              onBlur={() => this.onBlur('emailFocus')}
            />
          </Label>
          <Button type="submit" disabled={this.state.loading} onClick={this.handleSubmit}>
            {!this.state.loading ? (
              'Continuar'
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#FFFFFF"
                loading={this.state.loading}
              />
            )}
          </Button>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(verifyStoreRole, { name: 'verifyStoreRole', withRef: true }),
)(VerifyRoleFormModal);
